const parseEv = (ev) => {
  const _ev = ev[ev.length - 1] === '@' ? ev.slice(0, ev.length - 1) : ev;
  return _ev.split('@');
}

const createBrand = (paresEvArr, obj) => {
  const brandIndex = paresEvArr.findIndex(item => item.startsWith('exbrand'));
  if (brandIndex !== -1) {
    obj.brands = (paresEvArr.splice(brandIndex, 1)[0].replace(/exbrand_/, '').split('||'))
  }
}

const createPrice = (paresEvArr, obj) => {
  const priceIndex = paresEvArr.findIndex(item => item.startsWith('exprice'));
  if (priceIndex !== -1) {
    const priceArr = paresEvArr.splice(priceIndex, 1)[0].replace(/exprice_M/, '').split('L');
    priceArr[0] && (obj.pM = priceArr[0]);
    priceArr[1] && (obj.pL = priceArr[1]);
  }
}

const handleEv = (ev) => {
  if (!ev) return;
  const evObj = Object.create(null);
  const parseEvArr = parseEv(ev);
  createBrand(parseEvArr, evObj);
  createPrice(parseEvArr, evObj);
  if (parseEvArr.length) {
    evObj.extAttrs = parseEvArr;
  }
  return evObj
}

const handlePriceInListHTML = (ev) => {
  if (!ev) return;
  const evObj = Object.create(null);
  const parseEvArr = parseEv(ev);
  createPrice(parseEvArr, evObj);
  if(parseEvArr.length){
    evObj.ev = parseEvArr.join('@');
  }
  return evObj
}

const changeBrand_IdToName = (searchParamsBody, crumbs) => {
  const { ev = '' } = searchParamsBody;
  const exbrand = ev.match(/exbrand_\d+/g);
  const crumbBrand = crumbs.filter(crumb => crumb.crumbName === '品牌');
  if(exbrand?.length !== 0 && crumbBrand.length !== 0){
    const brandId = exbrand[0].split('_')[1];
    const crumbName = crumbBrand[0]?.content[0];
    return ev.replace(brandId, crumbName)
  }
  return ev
}

export {
  handleEv,
  handlePriceInListHTML,
  changeBrand_IdToName
}